// global app wrapper
// See https://nextjs.org/docs/basic-features/typescript#custom-app
import 'iframe-resizer/js/iframeResizer.contentWindow';
import 'what-input';
import type { AppProps } from 'next/app';

const AppWrapper = ({ Component, pageProps }: AppProps) => {
  return <Component {...pageProps} />;
};

export default AppWrapper;
